import React from 'react';
import './statCard.css';

export default function StatCard({ label, value, change, icon, positive = true }) {
  return (
    <div className="stat-card">
      <div className="stat-card-top">
        <span className="stat-card-label">{label}</span>
        <div className="stat-card-icon">{icon}</div>
      </div>
      <div className="stat-card-value">{value}</div>
      {change && (
        <div className={`stat-card-change ${positive ? 'positive' : 'negative'}`}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
            <path d={positive ? "M18 15l-6-6-6 6" : "M6 9l6 6 6-6"} stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {change}
        </div>
      )}
    </div>
  );
}